import useRefetchSchedule from "hooks/apollo/schedule/useRefetchSchedule";
import { useSchedulerState } from "hooks/state";
import debounce from "lodash/debounce";
import Authorization from "policies/Authorization";
import React, { useState } from "react";
import ScheduleHeaderView from "./ScheduleHeaderView";

export default function ScheduleHeaderContainer() {
  const [disabled, setDisabled] = useState(false);

  const {
    quickNavigate,
    changeVisibleStartDate,
    changeZoomLevel,
    state: { zoomLevel, visibleTimeRange },
  } = useSchedulerState();
  const refetchSchedule = useRefetchSchedule();
  const policy = Authorization.usePolicy();
  const canPublishSchedule = policy.canPublishSchedule(Authorization.EntityTypes.PublishedScheduleType);

  const disableNavigation = (func) => {
    setDisabled(true);
    func();
    debounce(() => setDisabled(false), 500)();
  };

  const handleZoomLevelChange = (newZoomLevel) => {
    disableNavigation(() => {
      changeZoomLevel({ zoomLevel: Number(newZoomLevel) });
    });
  };

  const handleDateChange = (date) => {
    if (!date) return null;

    return refetchSchedule(changeVisibleStartDate({ startDate: date }));
  };
  const handleQuickNavigationChange = (option) => {
    disableNavigation(() => {
      refetchSchedule(quickNavigate({ quickNavigationOption: option }));
    });
  };

  return (
    <ScheduleHeaderView
      canPublishSchedule={canPublishSchedule}
      disabled={disabled}
      onDateChange={handleDateChange}
      onQuickNavigationChange={handleQuickNavigationChange}
      onZoomLevelChange={handleZoomLevelChange}
      visibleTimeRange={visibleTimeRange}
      zoomLevel={zoomLevel}
    />
  );
}
